// Shared, non-modal header panels. The icon links keep their normal navigation.
jQuery(function ($) {
    const desktop = window.matchMedia('(min-width: 1201px) and (hover: hover)');
    const triggerSelector = '.js-product-preview-trigger';
    let activeId = null;
    let closeTimer = null;

    function panel() { return activeId ? document.getElementById(activeId) : null; }
    function trigger() {
        return activeId ? document.querySelector('[data-product-preview="' + activeId + '"]') : null;
    }
    function cancelClose() { window.clearTimeout(closeTimer); }
    function close() {
        cancelClose();
        const current = panel();
        if (current) { current.hidden = true; current.classList.remove('is-open'); }
        activeId = null;
    }
    function open(link) {
        if (!desktop.matches) return;
        const id = link.getAttribute('data-product-preview');
        const next = document.getElementById(id);
        if (!next) return;
        cancelClose();
        if (activeId !== id) close();
        activeId = id;
        if (next.hidden) {
            next.hidden = false;
            // Commit the closed CSS state before starting the original transition.
            // A panel revealed from display:none otherwise opens without animating.
            next.getBoundingClientRect();
        }
        next.classList.add('is-open');
        $(document).trigger('myl:preview:open', [next]);
    }
    function scheduleClose() {
        cancelClose();
        closeTimer = window.setTimeout(function () {
            const current = panel();
            const link = trigger();
            const focused = document.activeElement;
            if (current && (current.contains(focused) || link === focused || current.matches(':hover') || (link && link.matches(':hover')))) return;
            close();
        }, 160);
    }
    $(document).on('mouseenter focusin', triggerSelector, function () { open(this); });
    $(document).on('mouseleave focusout', triggerSelector + ', .product-preview', scheduleClose);
    $(document).on('mouseenter focusin', '.product-preview', cancelClose);
    $(document).on('keydown', function (event) {
        if (event.key !== 'Escape' || !activeId) return;
        const current = panel();
        const link = trigger();
        if (current && current.contains(document.activeElement) && link) link.focus();
        close();
    });
    $(document).on('pointerdown', function (event) {
        const current = panel();
        const link = trigger();
        if (current && !current.contains(event.target) && link && !link.contains(event.target)) close();
    });
    desktop.addEventListener('change', close);
    // Woo replaces the cart wrapper through fragments. Restore its open state.
    $(document.body).on('wc_fragments_refreshed wc_fragments_loaded added_to_cart removed_from_cart', function () {
        const link = trigger();
        if (link) open(link);
    });
});
